export default __webpack_public_path__ + "static/media/cepeda.f147dd32.png";